const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-deck', 'forum/columns/PostListSource');